export default "__VITE_ASSET__whPd0z0T__"